// src/api/paymentsService.ts
import apiClient from './config';
import { CreateCheckoutSessionResponse, PaypalCreateResponse } from '../types/interfaces';

export const createCheckoutSession = async (
  reportId: string,
  currency: string = 'USD',
  languageCode: string = 'en'
): Promise<string> => {
  try {
    const response = await apiClient.post<CreateCheckoutSessionResponse>(
      '/payments/create-checkout-session',
      {
        report_id: reportId,
        currency,
        language_code: languageCode,
      }
    );

    return response.data.url;
  } catch (error) {
    throw error;
  }
};

export const createCheckoutSessionTokens = async (n: number, cur: string) =>
  (await apiClient.post('/payments/create-checkout-session-tokens', {
      num_tokens: n, currency: cur.toLowerCase()
  })).data;



export const createPaypalOrder = async (
  reportId: string,
  currency = 'USD',
  language = 'en'
): Promise<PaypalCreateResponse> => {
  const { data } = await apiClient.post<PaypalCreateResponse>(
    '/payments/paypal/create-order',
    {
      report_id:    reportId,
      currency,
      language_code: language,
    }
  );
  return data;
};

export const capturePaypalOrder = async (orderId: string) => {
  return apiClient.post('/payments/paypal/capture-order', { order_id: orderId });
};


export const createPaypalTokensOrder = async (n: number, cur: string) =>
  (await apiClient.post('/payments/paypal/tokens/create-order', {
      num_tokens: n, currency: cur.toLowerCase()
  })).data;

export const capturePaypalTokensOrder = (orderId: string) =>
  apiClient.post("/payments/paypal/tokens/capture-order", { order_id: orderId });